import React from 'react';
import '../css/Collab.css';

const ProductCard = ({
  productImage,
  productTitle,
  isVegan = false,
  isGlutenFree = false,
  veganIcon,
  glutenFreeIcon,
  subtitle,
  retailLabel = 'Retail',
  showRetailLabel = true,
  retailPrice,
  retailUnit,
  wholesaleLabel = 'Wholesale',
  showWholesale = true,
  wholesalePrice,
  wholesaleUnit,
  description,
  extraInfo,
  hidden = false,
}) => {
  return (
    <div className={`product-card ${hidden ? 'is-hidden' : ''}`}>
      <div className="product-image">
        <img src={productImage} alt={productTitle} />
      </div>

      <div className="product-info">
        <div className="product-title">
          <h3>{productTitle}</h3>
          {isVegan && veganIcon && (
            <img src={veganIcon} alt="Vegan" className="vegan-icon" />
          )}
          {isGlutenFree && glutenFreeIcon && (
            <img src={glutenFreeIcon} alt="Gluten Free" className="vegan-icon" />
          )}
        </div>
        {subtitle && <div className="product-subtitle">{subtitle}</div>}

        {retailPrice != null && (
          <span className="product-price">
            {showRetailLabel ? `${retailLabel}: ` : null}
            <strong>{retailPrice}</strong>
            {retailUnit ? ` ${retailUnit}` : null}
          </span>
        )}

        {showWholesale && (wholesalePrice != null || wholesaleUnit) && (
          <span className="product-price">
            {wholesaleLabel ? `${wholesaleLabel}: ` : null}
            {wholesalePrice != null ? <strong>{wholesalePrice}</strong> : null}
            {wholesaleUnit ? ` ${wholesaleUnit}` : null}
          </span>
        )}
        {description && (
          <p>{description}</p>
        )}
        {extraInfo && (
          <span className="product-extra-info">{extraInfo}</span>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
